
import React, { useEffect, useState } from 'react';
import {
    TextField,
    MenuItem,
    Grid,
    Button,
    Typography,
    Paper,
    Divider,
    Box,
    IconButton,
} from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import "./KrapKpiManagement.css"
import { toast, ToastContainer } from 'react-toastify';
import actions from '../../../ReduxStore/actions';
import { useNavigate, useParams } from 'react-router-dom';

const years = ['2023', '2024', '2025'];
const kraOptions = ['STORES-7725', 'SALES-8821'];

const KrapKpiManagemenEdit = () => {
    const [selectedKra, setSelectedKra] = useState('');
    const [selectedYear, setSelectedYear] = useState('');

    const [selectedKraId, setSelectedKraId] = useState('');
    const [selectedYearId, setSelectedYearId] = useState('');

    const [kraKpiId, setKraKpiId] = useState('');
    const [sections, setSections] = useState([]);
    console.log(sections, "sectionrghdr")
    const { id } = useParams()
    const { getQuestionById } = useSelector((state) => state?.getQuestionById);
    // useEffect(() => {
    //     getQuestionById?.data?.mapd((data) => ({

    //     }))

    // }, [])


    // useEffect(() => {
    //     const fetchData = async () => {

    //         const data1 = {
    //             data: {},
    //             method: "get",
    //             apiName: `getAllKraKpi/${id}`
    //         };
    //         const responseData = dispatch(actions.GETALLKRAKPI(data1));
    //         console.log(responseData, "responseData")


    //     }
    //     fetchData()

    // }, [])


    // const handleKraChange = (value) => {
    //     setSelectedKra(value);
    //     generateKraKpiId(value, selectedYear);
    // };z// useEffect(() => {
    //     const fetchData = async () => {

    //         const data1 = {
    //             data: {},
    //             method: "get",
    //             apiName: `getAllKraKpi/${id}`
    //         };
    //         const responseData = dispatch(actions.GETALLKRAKPI(data1));
    //         console.log(responseData, "responseData")


    //     }
    //     fetchData()

    // }, [])


    // const handleKraChange = (value) => {
    //     setSelectedKra(value);
    //     generateKraKpiId(value, selectedYear);
    // };
    useEffect(() => {
        // const rawData = getQuestionById?.data;
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: `getQuestionById/${id}`
            };
            const responseData = await dispatch(actions.GETQUESTIONBYIID(data1));
            if (responseData?.payload?.message === "KRA/KPI questions successfully.") {
                const rawData = responseData?.payload?.data
                console.log(rawData, "rawDatarawDatarawDatarawData")







                if (rawData) {

                    const kraKpiId = `KRAKPI${rawData?.kra_kpi_name.replace(/\s+/g, "")}${rawData?.kra_kpi_id}`;
                    setSelectedKraId(rawData?.kra_kpi_id)
                    setSelectedYearId(rawData?.appraisal_year_id)
                    setKraKpiId(kraKpiId)
                    setSelectedKra(rawData?.kra_kpi_name)

                    setSelectedYear(rawData?.appraisal_year)
                    console.log(rawData?.kra_kpi_questions, "rawData")

                    // const sections = rawData?.kra_kpi_questions?.map(
                    const sections = rawData?.kra_kpi_questions?.map(
                        (kraValue, kraKey) => ({

                            kraId: `${kraKpiId}_${`KRA_0${kraKey + 1}`}`,
                            // const kraId = `${kraKpiId}`;

                            kratitle: kraValue?.[`KRA_0${kraKey + 1}`]?.Parameter,
                            weight: kraValue?.[`KRA_0${kraKey + 1}`]?.Weightage,

                            kpis: kraValue?.[`KRA_0${kraKey + 1}`]?.KPIs?.map((kpiValue, kpiKey) => ({
                                kpiId: `${kraKpiId}_${`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`}`,
                                parameter: kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Parameter,
                                weight: String(kpiValue?.[`KRA_0${kraKey + 1}_KPI_0${kpiKey + 1}`]?.Weightage)
                            }))


                        })
                    );

                    // const finalData = {
                    //     // kraKpiId,
                    //     sections
                    // };
                    console.log(sections, "sectionssectionssections")
                    setSections(sections);
                    // console.log("Transformed Data:", finalData);

                }
            }
        }

        fetchData()

    }, [id]);


    const handleKraChange = (selectedValue) => {
        // const selectedOption = kraKpiNameOptions.find(kra => kra.value === selectedValue);
        const selectedOption = kraKpiNameOptions.find(
            name => String(name.value) === String(selectedValue)
        );
        console.log("Selected KRA ID (value):", selectedValue);
        setSelectedKraId(selectedValue)
        console.log("Selected KRA Label:", selectedOption?.label);
        setSelectedKra(selectedOption?.label);
        generateKraKpiId(selectedOption?.label, selectedYear);

    };


    // const handleYearChange = (value) => {
    //     setSelectedYear(value);
    //     generateKraKpiId(selectedKra, value);
    // };
    const handleYearChange = (selectedValue) => {
        console.log(kraKpiYearOptions, "kraKpiYearOptions")
        console.log(kraKpiYearOptions, "")
        // const selectedOption = kraKpiYearOptions.find(year => year.value === selectedValue);
        const selectedOption = kraKpiYearOptions.find(
            year => String(year.value) === String(selectedValue)
        );

        console.log(selectedOption, "selectedOption")

        console.log("Selected Year ID (value):", selectedValue);
        setSelectedYearId(selectedValue)
        console.log("Selected Year Label:", selectedOption?.label);
        setSelectedYear(selectedOption?.label);
        generateKraKpiId(selectedKra, selectedOption?.label);

    };


    const generateKraKpiId = (kra, year) => {
        console.log(kra, year, "hiihihi")
        if (kra && year) {
            console.log("hiihihi1111")
            const yearRange = "2024-25";
            const shortYear = yearRange.split("-")[1]; // "25"
            setKraKpiId(`KRAKPI${kra.trim()}${shortYear}`);


        }
    };

    const addSection = () => {
        const newIndex = sections?.length + 1;
        setSections([
            ...sections,
            {
                kraId: `${kraKpiId}_KRA_${newIndex.toString().padStart(2, '0')}`,
                kratitle: "",
                weight: "",


                kpis: [
                    {
                        kpiId: `KRAKP${selectedKra}_KRA_${newIndex.toString().padStart(2, '0')}_KPI_01`,
                        parameter: '',
                        weight: '',
                    },
                ],
            },
        ]);
    };

    const addKpi = (index) => {
        const newSections = [...sections];
        const kpiCount = newSections[index].kpis.length + 1;
        newSections[index].kpis.push({
            kpiId: `${newSections[index].kraId}_KPI_${kpiCount.toString().padStart(2, '0')}`,
            parameter: '',
            weight: '',
        });
        setSections(newSections);
    };

    // const handleInputChange = (sectionIndex, kpiIndex, field, value) => {
    //     const updatedSections = [...sections];
    //     console.log(updatedSections, "updatedSections")
    //     updatedSections[sectionIndex].kpis[kpiIndex][field] = value;
    //     setSections(updatedSections);
    // };
    // const handleInputChange = (sectionIndex, kpiIndexOrField, fieldOrValue, value) => {
    //     console.log(sectionIndex, kpiIndexOrField, fieldOrValue, value, "hihiihiihihihiih")
    //     setSections((prevSections) =>
    //         prevSections.map((section, idx) => {
    //             if (idx !== sectionIndex) return section;

    //             // Handle section-level fields
    //             if (typeof kpiIndexOrField === "string") {
    //                 return {
    //                     ...section,
    //                     [kpiIndexOrField]: fieldOrValue, // i.e., fieldOrValue = value
    //                 };
    //             }

    //             // Handle KPI-level fields
    //             const kpiIndex = kpiIndexOrField;
    //             const field = fieldOrValue;

    //             const updatedKpis = section.kpis.map((kpi, kpiIdx) =>
    //                 kpiIdx === kpiIndex ? { ...kpi, [field]: value } : kpi
    //             );

    //             return {
    //                 ...section,
    //                 kpis: updatedKpis,

    //             };
    //         })
    //     );
    // };
    const handleInputChange = (sectionIndex, kpiIndexOrField, fieldOrValue, value) => {
        setSections((prevSections) =>
            prevSections.map((section, idx) => {
                if (idx !== sectionIndex) return section;

                // Handle section-level fields (like kratitle)
                if (typeof kpiIndexOrField === "string") {
                    return {
                        ...section,
                        [kpiIndexOrField]: fieldOrValue,
                    };
                }

                // Handle KPI-level fields
                const kpiIndex = kpiIndexOrField;
                const field = fieldOrValue;

                const updatedKpis = section?.kpis.map((kpi, kpiIdx) =>
                    kpiIdx === kpiIndex ? { ...kpi, [field]: value } : kpi
                );

                const updatedSection = {
                    ...section,
                    kpis: updatedKpis,
                };

                // Update total section weight explicitly (if you store it)
                updatedSection.weight = getKraWeightTotal(updatedSection);

                return updatedSection;
            })
        );
    };



    const handleDeleteKpi = (sectionIndex, kpiIndex) => {
        const updatedSections = [...sections];
        updatedSections[sectionIndex].kpis.splice(kpiIndex, 1);
        setSections(updatedSections);
    };

    const handleDeleteSection = (sectionIndex) => {
        const updatedSections = [...sections];
        updatedSections.splice(sectionIndex, 1);
        setSections(updatedSections);
    };

    const getKraWeightTotal = (section) => {
        return section?.kpis?.reduce((total, kpi) => total + Number(kpi.weight || 0), 0);
    };

    const getOverallWeightTotal = () => {
        return sections?.reduce((total, section) => total + getKraWeightTotal(section), 0);
    };
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()
    const handleSubmit = async () => {
        setLoading(true)
        if (getOverallWeightTotal() !== 100) {
            alert('Total weightage must be 100% before submitting.');
            return;
        }

        // if (!selectedKra || !selectedYear) {
        //     alert('Please select KRA and Year.');
        //     return;
        // }


        const hasEmptyFields = sections?.some(section =>
            section?.kpis.some(kpi => !kpi.parameter || !kpi.weight)
        );
        const hasEmptyFieldsHeading = sections?.some(section =>
            !section?.kratitle
        );

        const hasMissingSelections = !selectedKra || !selectedYear;
        const invalidTotal = getOverallWeightTotal() !== 100;

        if (hasEmptyFields || hasMissingSelections || invalidTotal || hasEmptyFieldsHeading) {
            if (hasEmptyFields) {
                toast.error("Please fill out all required KPI fields or empty KPI Feilds remove.");
            } else if (hasEmptyFieldsHeading) {
                toast.error("Please fill out all KRA fields");
            }

            else if (invalidTotal) {
                toast.error("Total weight must be exactly 100%.");
            } else if (hasMissingSelections) {
                toast.error("Please select both KRA and Year.");
            }

            return


        }

        // Proceed with actual submit logic
        const formData = {
            kra: selectedKra,
            year: selectedYear,
            kraKpiId,
            sections,
        };

        console.log('Submitted Data:', formData);

        const data1 = {
            data: {
                kra_kpi_id: selectedKraId,
                appraisal_year_id: selectedYearId,
                kra_kpi_questions: formData?.sections?.map((section, index) => ({
                    [`KRA_0${index + 1}`]: {  // Dynamically generate KRA_01, KRA_02, etc.
                        Parameter: section?.kratitle,  // KRA Title (e.g., "eew")
                        Weightage: section?.weight,  // KRA Weightage
                        KPIs: section?.kpis.map((kpi, kpiIndex) => ({
                            [`KRA_0${index + 1}_KPI_0${kpiIndex + 1}`]: {

                                // kpiId: kpi.kpiId,  // KPI ID (e.g., KRAKPCustomer125_KRA_01_KPI_01)
                                Parameter: kpi?.parameter,  // KPI Parameter (e.g., "ew")
                                Weightage: parseInt(kpi?.weight)  // KPI Weightage (convert string to integer)
                            }
                        }))
                    }
                }))

            },
            method: "put",
            apiName: `updateQuestion/${id}`
        };
        const responseData = await dispatch(actions.CRETEKRAKPIQUESTIONFORKRAKPI(data1));
        console.log(responseData, "responseDataresponseData")
        if (responseData?.payload?.message === "Updated successfully.") {
            setLoading(false)
            toast.success("KRA/KPI question update successfully.");
            setTimeout(() => {
                navigate("/admin/rolewisekrakpi")
            }, 2500)

            setSelectedKra()
            setSelectedYear()
            setSelectedKraId()
            setSelectedYearId()
            setSections()
            setTimeout(() => {
                navigate("/admin/rolewisekrakpi")
            }, 2000)

        } else {
            setLoading(false)
            toast.error(responseData?.payload?.message)
        }
        // You can replace this console log with an API call or Redux dispatch
    };
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setHeaderName("Create New KRA & KPI"));
        dispatch(setSubHeaderName(""));
    }, [dispatch]);

    const { getAllKraKpi } = useSelector((state) => state?.getAllKraKpi);
    console.log(getAllKraKpi, "getAllKraKpi")

    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllKraKpi"
            };
            const responseData = dispatch(actions.GETALLKRAKPI(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [])
    const kraKpiNameOptions = getAllKraKpi?.data?.map((data) => (
        { value: data?.kra_kpi_id, label: data?.kra_kpi_name }
    ))

    const { getAllAppraisalYears } = useSelector((state) => state?.getAllAppraisalYears);
    console.log(getAllAppraisalYears, "getAllAppraisalYears")

    useEffect(() => {
        const fetchData = async () => {

            const data1 = {
                data: {},
                method: "get",
                apiName: "getAllAppraisalYears"
            };
            const responseData = dispatch(actions.GETALLAPPRAISALYEAR(data1));
            console.log(responseData, "responseData")


        }
        fetchData()

    }, [])
    const kraKpiYearOptions = getAllAppraisalYears?.data?.map((data) => (
        { value: data?.appraisal_year_id, label: data?.appraisal_year }
    ))





    return (
        <Box sx={{ p: 2 }}>
            <Box sx={{ background: "white", px: 3, py: 4 }}>
                <Typography variant="h5" gutterBottom sx={{ color: "black" }}>
                    Create New KRA & KPI
                </Typography>

                <Grid container spacing={2} mb={3} sx={{ mt: 4 }}>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <Typography variant="subtitle2" gutterBottom sx={{ color: "#514b4b" }}>
                            Select KRA & KPI
                        </Typography>
                        <select
                            disabled
                            value={selectedKraId}
                            onChange={(e) => handleKraChange(e.target.value)}
                            style={{ width: '100%', padding: '8px', borderRadius: '4px', height: "45px", borderColor: "#c9c5c5", background: "#f0f0f0" }}
                        >
                            <option value="">--Select KRA & KPI--</option>
                            {kraKpiNameOptions?.map((kra) => (
                                <option key={kra?.value} value={kra?.value}>
                                    {kra?.label}
                                </option>
                            ))}
                        </select>

                    </Grid>
                    <Grid item size={{ xs: 12, md: 4 }}>
                        <Typography variant="subtitle2" gutterBottom sx={{ color: "#514b4b" }}>
                            Select Year of Appraisal
                        </Typography>
                        <select
                            className='readonly-input'
                            disabled
                            // style={{  }}

                            value={selectedYearId}
                            onChange={(e) => handleYearChange(e.target.value)}
                            style={{ width: '100%', padding: '8px', borderRadius: '4px', height: "45px", borderColor: "#c9c5c5", background: "#f0f0f0" }}
                        >
                            <option value="">--Select Year Appraisal--</option>
                            {kraKpiYearOptions?.map((years) => (
                                <option key={years?.value} value={years?.value}>
                                    {years?.label}
                                </option>
                            ))}
                        </select>

                        {/* <TextField
                            select
                            fullWidth
                            label="Year of Assessment"
                            value={selectedYear}
                            onChange={(e) => handleYearChange(e.target.value)}
                        >
                            {years?.map((year) => (
                                <MenuItem key={year} value={year}>
                                    {year}
                                </MenuItem>
                            ))}
                        </TextField> */}
                    </Grid>
                    <Grid item size={{ xs: 12, md: 4 }}>

                        <Typography variant="subtitle2" gutterBottom sx={{ color: "#514b4b" }}>
                             KRA & KPI Id(Auto Generated)
                        </Typography>
                        <input
                            className='readonly-input'
                            label="Kra_Kpi_Id (Auto Generated)"
                            style={{ width: '100%', padding: '8px', borderRadius: '4px', height: "45px", border: "1px solid #c9c5c5", outline: 'none', background: "#f0f0f0" }}
                            // fullWidth
                            value={kraKpiId}
                            disabled



                        // InputProps={{ readOnly: true }}
                        />
                    </Grid>
                </Grid>
            </Box>

            {
                sections?.map((section, sectionIndex) => (
                    <Paper key={section?.kraId} elevation={3} sx={{ p: 2, mt: 3 }}>

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h5" gutterBottom sx={{ color: "black" }}>
                                {section?.kraId}
                            </Typography>

                            <IconButton onClick={() => handleDeleteSection(sectionIndex)}>
                                <Delete style={{ fontSize: "20px", color: "rgb(243 13 13 / 60%)" }} />
                            </IconButton>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <Box sx={{ display: { sm: "block", xs: "none" } }}>
                            <Grid container spacing={2}>
                                <Grid item size={{ xs: 12, sm: 4.5 }}></Grid>
                                <Grid item size={{ xs: 12, sm: 4.5 }}>
                                    {/* <Typography>Question</Typography> */}
                                    <Typography variant="subtitle2" gutterBottom sx={{ color: "#514b4b" }}>
                                        {/* Select KRA & KPI */}
                                        Question
                                    </Typography>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 2 }}>
                                    {/* <Typography>Weightage (%)</Typography> */}
                                    <Typography variant="subtitle2" gutterBottom sx={{ color: "#514b4b" }}>

                                        Weightage (%)
                                    </Typography>

                                </Grid>
                            </Grid>
                        </Box>
                        <Grid container spacing={2} key={section?.kraId} alignItems="center" mt={2} sx={{ mb: 6, px: 2 }}>
                            <Grid item size={{ xs: 12, sm: 4.5 }} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <Typography variant="subtitle2" sx={{ color: "gray" }} >{section?.kraId}</Typography>

                            </Grid>
                            <Grid item size={{ xs: 12, sm: 4.5 }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ display: { xs: "block", sm: "none" }, color: "#514b4b" }}>
                                    {/* Select KRA & KPI */}
                                    Question
                                </Typography>
                                <TextField
                                    fullWidth
                                    // label="KRA Title"
                                    multiline
                                    rows={2}
                                    value={section?.kratitle}
                                    onChange={(e) =>
                                        handleInputChange(sectionIndex, 'kratitle', e.target.value)
                                    }
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 2 }}>
                                <Typography variant="subtitle2" gutterBottom sx={{ display: { xs: "block", sm: "none" }, color: "#514b4b" }}>
                                    {/* Select KRA & KPI */}
                                    Weightage(%)
                                </Typography>
                                <TextField
                                    fullWidth
                                    type="number"
                                    // label="Weightage (%)"]
                                    disabled
                                    inputProps={{ min: 0, max: 100 }}

                                    // value={getKraWeightTotal(section)}
                                    value={getKraWeightTotal(section)}

                                    sx={{ background: "#f0f0f0" }}
                                // onChange={(e) =>
                                //     handleInputChange(sectionIndex, 'weight', getKraWeightTotal(section))
                                // }

                                />

                            </Grid>

                        </Grid>

                        {section?.kpis.map((kpi, kpiIndex) => (
                            <Grid container spacing={2} key={kpi?.kpiId} alignItems="center" mt={2} sx={{ mb: 6, px: 2 }}>
                                <Grid item size={{ xs: 12, sm: 4.5 }} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <Typography variant="subtitle2" sx={{ color: "gray" }} >{kpi?.kpiId}</Typography>
                                    <IconButton onClick={() => handleDeleteKpi(sectionIndex, kpiIndex)} sx={{ display: { xs: "block", sm: "none" } }}>
                                        <Delete style={{ fontSize: "20px", color: "rgb(243 13 13 / 60%)" }} />
                                    </IconButton>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 4.5 }}>
                                    <Typography variant="subtitle2" gutterBottom sx={{ display: { xs: "block", sm: "none" }, color: "#514b4b" }}>
                                        {/* Select KRA & KPI */}
                                        Question
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={2}
                                        // label="Parameter"
                                        value={kpi?.parameter}
                                        onChange={(e) =>
                                            handleInputChange(sectionIndex, kpiIndex, 'parameter', e.target.value)
                                        }
                                    // error={formSubmitted && ! kpi?.parameter}
                                    // helperText={formSubmitted && ! kpi?.parameter ? "Parameter is required" : ""}
                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 2 }}>
                                    <Typography variant="subtitle2" gutterBottom sx={{ display: { xs: "block", sm: "none" }, color: "#514b4b" }}>
                                        {/* Select KRA & KPI */}
                                        Weightage(%)
                                    </Typography>
                                    <TextField
                                        type="number"
                                        fullWidth
                                        inputProps={{ min: 0, max: 100 }}
                                        value={kpi?.weight}
                                        // onChange={(e) =>
                                        //     handleInputChange(sectionIndex, kpiIndex, 'weight', e.target.value)
                                        // }
                                        onChange={(e) => {
                                            const value = Number(e.target.value);
                                            if (value <= 100 && value >= 0) {
                                                handleInputChange(sectionIndex, kpiIndex, 'weight', e.target.value);
                                            }
                                        }}
                                    // error={formSubmitted && ! kpi?.weight}
                                    // helperText={formSubmitted && ! kpi?.weight ? "Weight is required" : ""}

                                    />
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 1 }} sx={{ display: { sm: "block", xs: "none" } }}>
                                    <IconButton onClick={() => handleDeleteKpi(sectionIndex, kpiIndex)}>
                                        <Delete style={{ fontSize: "20px", color: "rgb(243 13 13 / 60%)" }} />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        ))}
                        <Divider />

                        <Box mt={2} sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", px: 3 }}>
                            <Button onClick={() => addKpi(sectionIndex)} variant="outlined" sx={{ border: "1px solid var(--main-color)", color: "var(--main-color)", textTransform: "none" }}>
                                Add KPI
                            </Button>
                            <Typography mt={1} variant="subtitle2" sx={{ color: "var(--main-color)" }}>
                                {section?.kraId} Total: {getKraWeightTotal(section)}%
                            </Typography>
                        </Box>
                    </Paper>
                ))
            }

            {/* Show add section only after KRA and Year selected */}
            {
                selectedKra && selectedYear && (
                    <>
                        <Button variant="contained" onClick={addSection} sx={{ mt: 2, textTransform: "none", background: "var(--main-color)", mt: 4 }}>
                            Add KRA Section
                        </Button>

                        <Typography variant="h6" mt={3}>
                            Overall Total: {getOverallWeightTotal()}%
                        </Typography>
                        {getOverallWeightTotal() !== 100 && (
                            <Typography color="error">Total weightage must be 100%</Typography>
                        )}

                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            disabled={getOverallWeightTotal() !== 100 || !selectedKra || !selectedYear}
                            sx={{ mt: 3, background: "var(--main-color)" }}
                        >
                            Update
                        </Button>
                    </>
                )
            }
            <ToastContainer position="top-right" autoClose={1500} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark" />

        </Box >
    );
};

export default KrapKpiManagemenEdit;
